import { configFromEnv } from "@utils/config";

export const configRefs = {
  apis: {
    webproever: configFromEnv.asString("WP_API"),
    loginconnector: configFromEnv.asString("LOGIN_CONNECTOR_API"),
    gas: configFromEnv.asString("GAS_API"),
  },

  video23: configFromEnv.asString("VIDEO23_API"),
};
